import { useCallback } from "react";
import { TextField } from "./Parts/index";
import { Button } from "@/components/Buttons";
import { ErrorMessage } from "@/components/Form/Parts/index";
import styles from "@/styles/Form.module.scss";
import { useCheckTokenTimeout } from "@/hooks";

export default function CouponCodeForm({ enable, register, apply, error }) {
  const { checkTokenTimeoutAndRedirectOnError } = useCheckTokenTimeout();
  const handleClick = useCallback(async () => {
    const res = await checkTokenTimeoutAndRedirectOnError();
    if (
      res?.checkTokenTimeout?.result === true &&
      typeof apply === "function"
    ) {
      apply();
    }
  }, [apply]);

  if (!enable) return null;

  return (
    <div className={styles.couponCode}>
      <div className={styles.explanation}>
        <p>
          クーポンコードをお持ちの方は入力後、適用ボタンを押してください。
          <br />
          クーポンと他の割引キャンペーンがある場合、最も割引額の大きい割引が適用されます。
        </p>
      </div>
      <div>
        <ErrorMessage msg={error} />
      </div>
      <div className={styles.formGroup}>
        <TextField
          {...register("couponCode")}
          placeholder="お持ちの場合はコードを入力してください"
        />
        <Button fillColor small inline onClick={handleClick}>
          適用
        </Button>
      </div>
    </div>
  );
}
